import React, { useState, useEffect } from "react";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import _, { isEmpty } from "lodash";
import { connect } from "react-redux";
import { setTiles } from "../../redux/actions/postActions";
import cleanURL from "../../common/cleanURL";
import { Link } from "react-router-dom";

// interface prop {
//   categoriesArray?: any;
//   tiles:any
//   props?: any;
// }

function MenuBar(props) {
  const [categories, setCategories] = useState([]);
  const [miniBanners, setMiniBanners] = useState<any>([{}]);
  const [leftBannerText, setLeftBannerText] = useState<any>([]);
  const [leftBannerTnC, setleftBannerTnC] = useState<string>("");
  const [rightBannerText, setRightBannerText] = useState("");
  const [leftNavigation, setLeftNavigation] = useState<any>("");
  const [sortedLeftItem, setSortedLeftItem] = useState<any>();
  const [sortedRightItem, setSortedRightItem] = useState<any>();
  const [rightNavigation, setRightNavigation] = useState<any>("");
  const [hideMenu, setHideMenu] = useState(false);
  const [showLeftCursor, setShowleftCursor] = useState(false);
  const [showRightCursor, setShowRightCursor] = useState(false);
  useEffect(() => {
    getData();
    getShoutouts();
  }, [props?.props?.allCategories]);
  useEffect(() => {
    setHideMenu(false);
  }, [hideMenu]);
  const getData = async () => {
    if (props?.props?.allCategories) {
      let tempCategories: any = [];
      props?.props?.allCategories?.map((item) => {
        if (item?.Description !== "hidden") {
          tempCategories = [...tempCategories, item];
        }
      });
      // setCategories(tempCategories)
      getMenuBanners(tempCategories);
    } else {
      getCategories();
    }
    await getTiles();
  };

  const getMenuBanners = async (CategoriesList) => {
    await new WebApiCalls().getMenuBanners().then((response) => {
      let temp = response?.data;
      temp?.map((item, index) => {
        if (item?.status !== "Y") {
          temp.splice(index, 1);
        }
      });
      temp?.sort(function (a, b) {
        var dateA: any = new Date(a.publish_date),
          dateB: any = new Date(b.publish_date);
        return dateA - dateB;
      });
      temp?.reverse();
      let uniq = _.uniqBy(temp, function (n: any) {
        return n.category_id;
      });
      // let uniq = response?.data
      uniq?.length > 0 &&
        uniq?.map((item) => {
          // if(item?.status !== "Y"){return}
          CategoriesList?.length > 0 &&
            CategoriesList?.map((cat) => {
              if (cat?.ID === item?.category_id) {
                cat.bannerType = item?.banner_type;
                if (item?.banner_type === "banner_featured") {
                  cat.miniBanners = JSON.parse(item?.name);
                } else {
                  cat.miniBrands = JSON.parse(item?.name);
                }
              }
            });
        });
      setCategories(CategoriesList);
    });
  };

  const getTiles = async () => {
    let miniTempArr: any = [];
    if (props?.tiles.length > 0) {
      props?.tiles.map((item: any) => {
        if (item.page == "estore_web_mini") {
          miniTempArr?.push(item);
        }
      });
    } else {
      await new WebApiCalls()
        .getTiles()
        .then((result) => {
          if (result && result.data && result.data && result.data.Items) {
            props?.setTiles(result.data.Items);
            result.data.Items.map((item: any) => {
              if (item.page == "estore_web_mini") {
                miniTempArr?.push(item);
              }
            });
          }
        })
        .catch((error) => {
          console.log("catch error ", error);
        });
    }
    let sortedMini = miniTempArr.sort((a, b) => {
      if (a.sort_order != b.sort_order) {
        return a.sort_order - b.sort_order;
      } else {
        return (
          new Date(b.published_at).getTime() -
          new Date(a.published_at).getTime()
        );
      }
    });
    setMiniBanners(sortedMini);
  };
  const getShoutouts = async () => {
    let leftRibbons: any = [];
    let rightRibbons: any = [];
    await new WebApiCalls().getShoutouts().then((_response) => {
      if (_response.data) {
        if (_response.data.length > 0) {
          _response.data.map((item) => {
            if (item.type == "LeftRibbon" && item.status == "Y") {
              leftRibbons.push(item);
            }
            if (item.type == "RightRibbon" && item.status == "Y") {
              rightRibbons.push(item);
            }
          });
          let sortedLeft = leftRibbons.sort((a, b) => {
            return (
              new Date(b.publish_date).getTime() -
              new Date(a.publish_date).getTime()
            );
          });

          setLeftBannerText(sortedLeft[0]?.description);
          if (sortedLeft[0]?.detail !== "--")
            setleftBannerTnC(sortedLeft[0]?.detail);

          let sortedRight = rightRibbons.sort((a, b) => {
            return (
              new Date(b.publish_date).getTime() -
              new Date(a.publish_date).getTime()
            );
          });
          /* for left navigation */
          let nav = JSON.parse(sortedLeft[0].navigation)
            ? JSON.parse(sortedLeft[0].navigation)
            : undefined;
          let leftNav =
            nav == undefined || nav == "undefined" || nav.section == ""
              ? "javascript:void(0)"
              : `${
                  nav.params.hidden
                    ? `/category-listing/${cleanURL(nav.params?.cat_name)}/${
                        nav?.params?.ID
                      }?Medium=${nav?.params?.CampaignMedium}&link=${
                        nav?.params?.link
                      }`
                    : nav.params.comingFromStore
                    ? `/brand/${cleanURL(nav.params?.screenName)}/${
                        nav.params.ID
                      }?Medium=${nav.params.CampaignMedium}&link=${
                        nav?.params?.link
                      }`
                    : nav.params?.blog_name
                    ? `/blog/${nav.params.ID}/${cleanURL(
                        nav.params.blog_name
                      )}?Medium=${nav.params?.CampaignMedium}&link=${
                        nav.params?.link
                      }`
                    : `/category/${cleanURL(nav.params.cat_name)}/${
                        nav.params.ID
                      }?Medium=${nav.params?.CampaignMedium}&link=${
                        nav.params?.link
                      }`
                }`;
          /*For Right navigation */
          let nav2 = JSON.parse(sortedRight[0].navigation)
            ? JSON.parse(sortedRight[0].navigation)
            : undefined;
          let rightNav =
            nav2 == undefined || nav2 == "undefined" || nav2.section == ""
              ? "javascript:void(0)"
              : `${
                  nav2.params.hidden
                    ? `/category-listing/${cleanURL(nav2.params?.cat_name)}/${
                        nav2?.params?.ID
                      }?Medium=${nav2?.params?.CampaignMedium}&link=${
                        nav2?.params?.link
                      }`
                    : nav2.params.comingFromStore
                    ? `/brand/${cleanURL(nav2.params?.screenName)}/${
                        nav2.params.ID
                      }?Medium=${nav2.params.CampaignMedium}&link=${
                        nav2?.params?.link
                      }`
                    : nav2.params?.blog_name
                    ? `/blog/${nav2.params.ID}/${cleanURL(
                        nav2.params.blog_name
                      )}?Medium=${nav2.params?.CampaignMedium}&link=${
                        nav2.params?.link
                      }`
                    : `/category/${cleanURL(nav2.params.cat_name)}/${
                        nav2.params.ID
                      }?Medium=${nav2.params?.CampaignMedium}&link=${
                        nav2.params?.link
                      }`
                }`;
          setSortedLeftItem(sortedLeft[0]);
          if (JSON.parse(sortedLeft[0]?.navigation)?.website_params?.nav_to) {
            console.log("control enter here--(1)");
            setShowleftCursor(true);
          }
          setSortedRightItem(sortedRight[0]);
          if (JSON.parse(sortedRight[0].navigation).website_params?.nav_to) {
            console.log("control enter here---(2)");
            setShowRightCursor(true);
          }
          // setLeftNavigation(leftNav)
          // setRightNavigation(rightNav)
          // console.log("Sorted here: ", leftNav, " ", rightNav);
          setRightBannerText(sortedRight[0]?.description);
        }
      }
    });
  };
  const getCategories = async () => {
    await new WebApiCalls().getAllCategoriesByHerarchy().then((response) => {
      if (response) {
        let tempCategories: any = [];
        response?.map((item) => {
          if (item?.Description !== "hidden") {
            tempCategories = [...tempCategories, item];
          }
        });
        // tempCategories?.length > 0 && tempCategories?.map((item: any) => {
        //   if (item?.Name?.toLowerCase() == "women" || item?.Name?.toLowerCase() == "accessories") {
        //     item.miniBanners = miniBanners
        //   }else{
        //   }
        // })
        // setCategories(tempCategories);
        getMenuBanners(tempCategories);
      }
    });
  };

  return (
    <>
      {/* shoutouts */}
      <div className="shoutouts">
        {/* ad */}
        <div
          className="ad teal"
          style={{ cursor: showLeftCursor ? "pointer" : "auto" }}
          onClick={() => {
            let nav = JSON.parse(sortedLeftItem.navigation)
              ? JSON.parse(sortedLeftItem.navigation)
              : undefined;
            let leftNav =
              nav == undefined || nav == "undefined" || nav.section == ""
                ? ""
                : `${
                    nav.params.hidden
                      ? `/categories-listing/${cleanURL(
                          nav.params?.cat_name
                        )}/${nav?.params?.ID}?Medium=${
                          nav?.params?.CampaignMedium
                        }&link=${nav?.params?.link}`
                      : nav.params.comingFromStore
                      ? `/brand/${cleanURL(nav.params?.screenName)}/${
                          nav.params.ID
                        }?Medium=${nav.params.CampaignMedium}&link=${
                          nav?.params?.link
                        }`
                      : nav.params?.blog_name
                      ? `/blog/${nav.params.ID}/${cleanURL(
                          nav.params.blog_name
                        )}?Medium=${nav.params?.CampaignMedium}&link=${
                          nav.params?.link
                        }`
                      : `/category/${cleanURL(nav.params.cat_name)}/${
                          nav.params.ID
                        }?Medium=${nav.params?.CampaignMedium}&link=${
                          nav.params?.link
                        }`
                  }`;

            if (leftNav) {
              props.props.history.push(leftNav, { from: "Home" });
              window.location.reload();
            }
          }}
        >
          <div className="ribbon-left">
            {/* <strong>{leftBannerText ? leftBannerText : ""}</strong> */}
            <span
              dangerouslySetInnerHTML={{
                __html: leftBannerText ? leftBannerText : "",
              }}
            />
            {/* <br /> */}
            {/* {leftBannerTnC ? leftBannerTnC : ""} */}
            <span
              dangerouslySetInnerHTML={{
                __html: leftBannerTnC ? leftBannerTnC : "",
              }}
            />
          </div>
        </div>
        {/* /ad */}

        {/* ad */}
        <div
          style={{ cursor: showRightCursor ? "pointer" : "auto" }}
          className="ad brown"
          onClick={() => {
            let nav = JSON.parse(sortedRightItem.navigation)
              ? JSON.parse(sortedRightItem.navigation)
              : undefined;
            let rightNav =
              nav == undefined || nav == "undefined" || nav.section == ""
                ? ""
                : `${
                    nav.params.hidden
                      ? `/categories-listing/${cleanURL(
                          nav.params?.cat_name
                        )}/${nav?.params?.ID}?Medium=${
                          nav?.params?.CampaignMedium
                        }&link=${nav?.params?.link}`
                      : nav.params.comingFromStore
                      ? `/brand/${cleanURL(nav.params?.screenName)}/${
                          nav.params.ID
                        }?Medium=${nav.params.CampaignMedium}&link=${
                          nav?.params?.link
                        }`
                      : nav.params?.blog_name
                      ? `/blog/${nav.params.ID}/${cleanURL(
                          nav.params.blog_name
                        )}?Medium=${nav.params?.CampaignMedium}&link=${
                          nav.params?.link
                        }`
                      : `/category/${cleanURL(nav.params.cat_name)}/${
                          nav.params.ID
                        }?Medium=${nav.params?.CampaignMedium}&link=${
                          nav.params?.link
                        }`
                  }`;

            if (rightNav) {
              props.props.history?.push(rightNav, { from: "Home" });
              window.location.reload();
            }
          }}
        >
          <div
            className=""
            dangerouslySetInnerHTML={{
              __html: rightBannerText ? rightBannerText : "",
            }}
          />
          {/* <strong>{rightBannerText !== "" && rightBannerText}</strong> */}
          {/* </div> */}
        </div>
        {/* /ad */}
      </div>
      {/* /shoutouts */}

      {/* mainmenu */}
      <div className="mainmenu-wrap">
        <nav className="mainmenu">
          {/* submenu */}
          {categories &&
            categories?.map((item: any, index) => {
              return (
                <div className="submenu" key={index}>
                  <Link
                    to={`/category/${cleanURL(item.Name)}/${item.ID}`}
                    className="submenubtn"
                  >
                    {item.Name.toUpperCase()}
                  </Link>
                  {hideMenu !== true && (
                    <div className="submenu-content">
                      <div className="wrap">
                        {/* links */}
                        <div className="links">
                          <div className="column">
                            {item?.ChildCategories?.map(
                              (item2: any, index2) => {
                                if (index2 < 6) {
                                  return (
                                    <Link
                                      to={`/category/${cleanURL(item2.Name)}/${
                                        item2.ID
                                      }`}
                                      key={index2}
                                    >
                                      {item2.Name}
                                    </Link>
                                  );
                                }
                              }
                            )}
                            {item?.ChildCategories.length <= 6 && (
                              <Link
                                to={`/category/${cleanURL(item.Name)}/${
                                  item.ID
                                }`}
                              >
                                View All &raquo;
                              </Link>
                            )}
                          </div>
                          {item?.ChildCategories.length > 6 && (
                            <div className="column">
                              {item?.ChildCategories?.map(
                                (item2: any, index2) => {
                                  if (index2 > 5) {
                                    return (
                                      <Link
                                        to={`/category/${cleanURL(
                                          item2.Name
                                        )}/${item2.ID}`}
                                        key={index2}
                                      >
                                        {item2.Name}
                                      </Link>
                                    );
                                  }
                                }
                              )}
                              {item?.ChildCategories.length < 13 && (
                                <Link
                                  to={`/category/${cleanURL(item.Name)}/${
                                    item.ID
                                  }`}
                                >
                                  View All &raquo;
                                </Link>
                              )}
                            </div>
                          )}

                          {item?.ChildCategories.length > 12 && (
                            <div className="column">
                              {item?.ChildCategories?.map(
                                (item2: any, index2) => {
                                  if (index2 > 11) {
                                    return (
                                      <Link
                                        key={index2}
                                        to={`/category/${cleanURL(
                                          item2.Name
                                        )}/${item2.ID}`}
                                      >
                                        {item2.Name}
                                      </Link>
                                    );
                                  }
                                }
                              )}
                              {item?.ChildCategories.length < 18 && (
                                <Link
                                  to={`/category/${cleanURL(item.Name)}/${
                                    item.ID
                                  }`}
                                >
                                  View All &raquo;
                                </Link>
                              )}
                            </div>
                          )}
                        </div>
                        {/* /links */}
                        {}
                        {/* right panel */}
                        <div
                          className="right-panel"
                          onClick={() => {
                            setHideMenu(true);
                          }}
                        >
                          {item?.bannerType === "banner_featured" &&
                            item?.miniBanners?.length > 0 &&
                            !isEmpty(item?.miniBanners[0]) && (
                              <Link
                                to={{
                                  pathname:
                                    item?.miniBanners[0]?.deeplink ==
                                      "undefined" ||
                                    item?.miniBanners[0]?.deeplink ==
                                      undefined ||
                                    JSON.parse(item?.miniBanners[0]?.deeplink)
                                      ?.section == ""
                                      ? "javascript:void(0)"
                                      : JSON.parse(
                                          item?.miniBanners[0]?.deeplink
                                        )?.params?.hidden
                                      ? `/categories-listing/${cleanURL(
                                          JSON.parse(
                                            item?.miniBanners[0]?.deeplink
                                          )?.params?.cat_name
                                        )}/${
                                          JSON.parse(
                                            item?.miniBanners[0]?.deeplink
                                          )?.params?.ID
                                        }?Medium=${
                                          JSON.parse(
                                            item?.miniBanners[0]?.deeplink
                                          )?.params?.CampaignMedium
                                        }&link=${
                                          JSON.parse(
                                            item?.miniBanners[0]?.deeplink
                                          )?.params?.link
                                        }`
                                      : new URL(
                                          JSON.parse(
                                            item?.miniBanners[0].deeplink
                                          )?.website_params.nav_to
                                        ).pathname,

                                  search:
                                    item?.miniBanners[0]?.deeplink ==
                                      "undefined" ||
                                    item?.miniBanners[0]?.deeplink ==
                                      undefined ||
                                    JSON.parse(item?.miniBanners[0]?.deeplink)
                                      ?.section == ""
                                      ? ""
                                      // : 
                                      // JSON.parse(
                                      //     item?.miniBanners[0]?.deeplink
                                      //   )?.params?.hidden
                                      // ? `?Medium=${
                                      //     JSON.parse(
                                      //       item?.miniBanners[0]?.deeplink
                                      //     )?.params?.CampaignMedium
                                      //   }&link=${
                                      //     JSON.parse(
                                      //       item?.miniBanners[0]?.deeplink
                                      //     )?.params?.link
                                      //   }`
                                      :`?Medium=${
                                        JSON.parse(
                                          item?.miniBanners[0]?.deeplink
                                        )?.params?.CampaignMedium
                                      }&link=${
                                        JSON.parse(
                                          item?.miniBanners[0]?.deeplink
                                        )?.params?.link
                                      }`,



                                  state: { from: "Menu" },
                                }}
                                className="item"
                                key={index}
                              >
                                <img
                                  src={item?.miniBanners[0]?.image_url}
                                  alt=""
                                />
                                {/* <div className="text">{item?.description}</div> */}
                              </Link>
                            )}
                          {item.miniBrands?.length > 0 &&
                            item?.miniBrands?.map((item2, index) => {
                              if (item?.banner_type == "banner_featured") {
                                return;
                              }
                              return (
                                <Link
                                  to={`/brand/${cleanURL(item2?.DisplayName)}/${
                                    item2?.ID
                                  }`}
                                  key={index}
                                  className="item"
                                >
                                  <img
                                    src={
                                      item2.CustomFields
                                        ? item2.CustomFields.filter((item2) =>
                                            item2.Name.includes("BannerURL")
                                          ).length > 0
                                          ? item2.CustomFields.filter((item2) =>
                                              item2.Name.includes("BannerURL")
                                            )[0].Values[0]
                                          : ""
                                        : ""
                                    }
                                  />
                                  <div
                                    className="text"
                                    style={{ fontSize: 14 }}
                                  >
                                    {item2?.DisplayName}
                                  </div>
                                </Link>
                              );
                            })}
                        </div>
                        {/* /right panel */}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          {categories.length > 0 && (
            <div className="submenu">
              <Link
                to={{ pathname: "/brands-list", state: { from: "Home" } }}
                className="submenubtn"
              >
                {"Brands".toUpperCase()}
              </Link>
            </div>
          )}
          {/* /submenu */}
        </nav>
      </div>
      {/* /mainmenu */}
    </>
  );
}

const mapStateToProps = (state) => {
  const { tiles } = state.UserReducer;
  return { tiles };
};
const actions = {
  setTiles,
};
export default connect(mapStateToProps, actions)(MenuBar);
